import { FilterHandler } from '../shared/filter-handler';

import { Ship } from './ship';

export class DataField {
  specie_name = '';
  specie_fao_code = '';
  total_weight: number;

  constructor(specie_name, specie_fao_code, total_weight) {
    this.specie_name = specie_name;
    this.specie_fao_code = specie_fao_code;
    this.total_weight = this.total_weight;
  }
}

export class PortAggregate {
  data: DataField[] = [];

  constructor(values: Object = {}) {
    Object.assign(this, values);
  }

  apiMap(values: Object = {}) {
    const port = new PortAggregate(values);
    return port;
  }
}

export class PortAggregateFilter extends FilterHandler {
  ship: Ship[] = [];
  start_date: string;
  end_date: string;

  constructor(values: Object = {}) {
    super();

    this.ship = [];
    this.start_date = '';
    this.end_date = '';

    this.unSerializedRouterParams(values);
  }
}



// WEBPACK FOOTER //
// ./src/app/_models/port-aggregate.ts